/* eslint-disable sort-imports */
import $ from 'jquery';
import ClipboardJS from 'clipboard';
import '../../../jsscripts/jquery/printThis.js';

function groupByColumnCells($rows) {
    return $rows.reduce((arr, $cells) => {
        $cells.forEach(($cell, index) => {
            if (!arr[index]) {
                arr[index] = [];
            }

            arr[index].push($cell);
        });

        return arr;
    }, []);
}

const categoryComparison = {
    _filteredIds: [],

    init: function () {
        $('.scrollerDiv').on('scroll', this._followContent);
        this.initTable();
        this._initOptionEvents();
        this._initFilterState();
        this._initShareOnTouch();
    },

    _initShareOnTouch: function () {
        var isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
        if (isTouch) {
            $('#copyURL').prop('readonly', false);
        }
    },

    _initOptionEvents: function () {
        new ClipboardJS('#copyButton');

        $('.printFrame')
            .off()
            .on('click', function () {
                $('#printThis').printThis();
            });

        $('.shareFrame').on('click', function () {
            $('#urlHolder').slideDown(625);
            $('#copyURL').select();
        });

        $('.resetFrame')
            .off()
            .on('click', () => {
                this._filteredIds = [];
                this._resetGrid();
            });

        $('.filterFrame')
            .off()
            .on('click', () => {
                this._updateFilteredIds();
                this._filterRows();
            });

        $('#productColumnAnchor input')
            .off()
            .on('change', () => {
                this._setAllCheckedState();
            });
    },

    //filtering:

    _initFilterState: function () {
        var $hfFilteredIds = $('#hfFilteredIds');
        if (!$hfFilteredIds.length) {
            return;
        }

        this._filteredIds = $.map($('#hfFilteredIds').val().split(','), function (value) {
            return parseInt(value, 10);
        });

        $('.vertStripCell input')
            .filter((index, element) => {
                return $.inArray($(element).data('id'), this._filteredIds) != -1;
            })
            .attr('checked', true);
        this._filterRows();
    },

    _setAllCheckedState: function () {
        $('.vertStripCell input').prop('checked', $('#productColumnAnchor input').is(':checked'));
    },

    _resetGrid: function () {
        $('.vertStripCell, .rowStrip').show();
        $('.vertStripCell input, #productColumnAnchor input').attr('checked', false);
        this._generateShareUrl();
    },

    _updateFilteredIds: function () {
        this._filteredIds = [];
        var $checked = $('.vertStripCell input:checked');

        $checked.each((index, element) => {
            var id = $(element).data('id');
            this._filteredIds.push(id);
        });
    },

    _filterRows: function () {
        if (this._filteredIds.length === 0) {
            return;
        }

        $('.vertStripCell, .rowStrip')
            .filter((index, element) => {
                return $.inArray($(element).data('id'), this._filteredIds) == -1;
            })
            .hide();

        this._generateShareUrl();
    },

    _generateShareUrl: function () {
        var url = $('#copyURL').data('baseurl');
        if (this._filteredIds.length > 0) {
            url += '?i=' + this._filteredIds.join('&i=');
        }
        $('#copyURL').val(url);
    },

    // scrolling:

    _followContent: function () {
        var $scrollerPos = $('#scrollingDiv').offset();
        $('.headStrip').offset({left: $scrollerPos.left});
        $('#verticalScrollingStrip').offset({top: $scrollerPos.top});
    },

    // init sizing:

    _getMaxColumnWidths: function (columnCells) {
        return columnCells.map($row => {
            return Math.max.apply(
                null,
                $row.map($cell => Math.round($($cell).outerWidth()))
            );
        });
    },

    _setCellWidths: function ($rows, columnWidths) {
        $rows.forEach($cells => {
            $cells.forEach(($cell, index) => {
                $cell.style.width = `${columnWidths[index]}px`;
            });
        });
    },

    _setWidths: function () {
        const $table = document.getElementById('tableWrapper');
        const $tableHeader = $table.querySelector('.headStrip');
        const $tableHeaderCells = Array.from($tableHeader.querySelectorAll('.stripCell'));
        const $scrollContainer = $table.querySelector('#scrollingDiv');
        const $tableBodyRows = Array.from($scrollContainer.querySelectorAll('.rowStrip'));
        const $tableBodyCells = $tableBodyRows.map($row => Array.from($row.querySelectorAll('.stripCell')));
        const $rows = [$tableHeaderCells].concat($tableBodyCells);

        $tableHeader.removeAttribute('style');
        $scrollContainer.removeAttribute('style');

        this._setCellWidths($rows, this._getMaxColumnWidths(groupByColumnCells($rows)));

        const totalWidth = $rows[0].map($cell => Math.round($($cell).outerWidth())).reduce((a, b) => a + b, 0);

        $tableHeader.style.width = `${totalWidth}px`;
        $scrollContainer.style.width = `${totalWidth}px`;
    },

    _checkRowHeights: function () {
        $('.vertStripCell a').each((index, element) => {
            var $this = $(element),
                fitHeight = 34,
                thisIndex;
            if ($this.height() > fitHeight) {
                thisIndex = $(element).parent().index();
                this._adjustRowHeight(thisIndex);
            }
        });
    },

    _adjustRowHeight: function (rowIndex) {
        var $vertCell = $('.vertStripCell').eq(rowIndex),
            $row = $('.rowStrip').eq(rowIndex),
            paddingOffset = 16,
            adjHeight = $vertCell.children('a').height() + paddingOffset;

        $vertCell.height(adjHeight);
        $row.children('.stripCell').height(adjHeight);
    },

    // sorting:
    _bindHeaderSortClicks: function () {
        $('.headStrip').on('click', '.stripCell', e => this._handleHeaderClick(e));
    },

    _handleHeaderClick: function (e) {
        $('.headStrip .stripCell').removeClass('liveHeader');
        $(e.currentTarget).addClass('liveHeader');
        this._doColumnSort();
    },

    _getColumnByIndex: function (index) {
        var $column = $(),
            $cell;

        $('.rowStrip')
            .not('tr')
            .each((i, element) => {
                $cell = $(element).children('.stripCell').eq(index);
                $column = $column.add($cell);
            });

        return $column;
    },

    _getSortOrder: function () {
        var sortOrder = $('.liveHeader').data('sortOrder') || 'za';
        if (sortOrder === 'za') {
            return 'az';
        }
        if (sortOrder === 'az') {
            return 'za';
        }
        return '';
    },

    _prepForSort: function (val) {
        // eslint-disable-next-line no-useless-escape
        var testVal = val.replace(/[^\d\-\.]/g, ''),
            symbols = ['', '-', '√', '--'];

        if ($.inArray(val, symbols) > -1) {
            return $.inArray(val, symbols);
        }
        if (!testVal.length) {
            return val;
        }
        testVal = parseFloat(testVal);
        if (isNaN(testVal)) {
            testVal = 0;
        }
        return testVal;
    },

    _sortRows: function (a, b) {
        var liveIndex = $('.liveHeader').index(),
            sortOrder = this._getSortOrder(),
            sortModifier = sortOrder === 'za' ? -1 : 1,
            aVal = $(a).children().eq(liveIndex).text().trim(),
            bVal = $(b).children().eq(liveIndex).text().trim();

        aVal = this._prepForSort(aVal);
        bVal = this._prepForSort(bVal);

        sortModifier = sortOrder === 'az' ? 1 : -1;

        if (aVal > bVal) {
            return 1 * sortModifier;
        }
        if (aVal < bVal) {
            return -1 * sortModifier;
        }

        return 0;
    },

    _sortColumn: function ($rows) {
        var sortOrder = this._getSortOrder(),
            $printTableBody = $('table .rowStrip').parent();

        $rows.sort((a, b) => this._sortRows(a, b));
        $('#scrollingDiv').empty().append($rows);
        $('.headStrip .stripCell').find('.sortIcon').attr('src', '/images/compare/unsorted.gif');
        $('.liveHeader')
            .data('sortOrder', sortOrder)
            .find('.sortIcon')
            .attr('src', '/images/compare/' + sortOrder + '.gif');

        this._sortByMatching($rows, '.vertStripCell', $('#verticalScrollingStrip'));
        this._sortByMatching($rows, 'table .rowStrip', $printTableBody);
    },

    _doColumnSort: function () {
        var $rows = $('.rowStrip').not('tr');
        this._sortColumn($rows);
    },

    _sortByMatching: function ($sortedRowsToMatch, rowToSortSelector, $rowContainer) {
        $sortedRowsToMatch.each((index, element) => {
            this._sortByMatchedId($(element), rowToSortSelector, $rowContainer);
        });
    },

    _sortByMatchedId: function ($currentRow, rowSelector, $rowContainer) {
        var thisID = $currentRow.data('id'),
            $matched = $(rowSelector + '[data-id=' + thisID + ']');
        $matched.appendTo($rowContainer);
    },

    //init:
    initTable: function () {
        var $anchorCell = $('.headStrip .stripCell:first');

        $('#productColumnAnchor').outerHeight($anchorCell.outerHeight());
        $('.scrollerDiv, #verticalScrollingStrip').css('margin-top', $anchorCell.outerHeight());
        this._bindHeaderSortClicks();
        this._setWidths();
        this._checkRowHeights();
    }
};

export default categoryComparison;
